import store from '../../../store'

export default {
  namespaced: true,
  state: {
    all: [],
  },
  mutations: {
    setCartItems(state, { motorId, articleNumber, amount }) {
      let item = store.getters['build/cart/motorConfigItems/getCartItemByMotorId'](motorId);

      if (item) {
        item.amount += amount;
      } else {
        state.all.push({
          motorId,
          articleNumber,
          amount,
        });
      }

      this.commit('cart/setCartState', true);
    },

    setItemAmount(state, payload) {
      if (payload.newAmount === 0) {
        const confirmed = confirm('Weet u zeker dat u deze motor uit uw systeem wilt halen?');

        if (confirmed) {
          state.all = state.all.filter((cartItem) => {
            return cartItem.motorId !== payload.motorId;
          });
        }
      } else {
        let item = store.getters['build/cart/motorConfigItems/getCartItemByMotorId'](payload.motorId);
        item.amount = payload.newAmount;
      }
    },
  },

  getters: {
    getCartItemByMotorId: (state) => (motorId) => {
      return state.all.find(item => item.motorId === motorId);
    },
  },
};
